const getFieldsCompleteChildren = (obj, requiredKeys) => Object.fromEntries(
    // eslint-disable-next-line no-unused-vars
    Object.entries(obj).filter(([_, child]) =>
      requiredKeys.every(key => child[key] !== undefined && child[key] !== null && child[key] !== "" && 
        !(typeof child[key] === "object" && Object.keys(child[key]).length === 0))
    )
  );

  // eslint-disable-next-line import/prefer-default-export
  export { getFieldsCompleteChildren }